import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import Guides from './pages/Guides';
import News from './pages/News';
import Reviews from './pages/Reviews';
import ChoisirPlateformeParis from './pages/guides/ChoisirPlateformeParis';
import ComprendreBonusBienvenue from './pages/guides/ComprendreBonusBienvenue';
import TypesParisSportifs from './pages/guides/TypesParisSportifs';
import GuideParisHippiques from './pages/guides/GuideParisHippiques';
import GestionBankroll from './pages/guides/GestionBankroll';
import StrategiesParis from './pages/guides/StrategiesParis';
import SecuriteProtectionDonnees from './pages/guides/SecuriteProtectionDonnees';
import RetraitsDepots from './pages/guides/RetraitsDepots';
import JeuResponsable from './pages/guides/JeuResponsable';
import NouvellesReglementationsAnj2025 from './pages/news/NouvellesReglementationsAnj2025';
import ComparatifBonusBienvenue2025 from './pages/news/ComparatifBonusBienvenue2025';
import TendancesParisSportifs2025 from './pages/news/TendancesParisSportifs2025';
import NouveauxOperateursMarcheFrancais from './pages/news/NouveauxOperateursMarcheFrancais';
import ImpactLiveBettingHabitudesParis from './pages/news/ImpactLiveBettingHabitudesParis';
import ProtectionJoueursNouvellesMesuresAnj from './pages/news/ProtectionJoueursNouvellesMesuresAnj';
import EvolutionCotesAnalyseComparative from './pages/news/EvolutionCotesAnalyseComparative';
import ParisHippiquesEreNumerique from './pages/news/ParisHippiquesEreNumerique';
import MethodesPaiement2025 from './pages/news/MethodesPaiement2025';
import Betclic from './pages/reviews/Betclic';
import Olybet from './pages/reviews/Olybet';
import Genybet from './pages/reviews/Genybet';
import PrivacyPolicy from './pages/PrivacyPolicy';
import Terms from './pages/Terms';
import Cookies from './pages/Cookies';
import ResponsibleGaming from './pages/ResponsibleGaming';
import AgeVerification from './components/AgeVerification';
import CookieConsent from './components/CookieConsent';
import ScrollToTop from './components/ScrollToTop';

function App() {
  return (
    <Router>
      <ScrollToTop />
      <AgeVerification />
      <CookieConsent />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/guides" element={<Guides />} />
        <Route path="/guides/choisir-plateforme-paris" element={<ChoisirPlateformeParis />} />
        <Route path="/guides/comprendre-bonus-bienvenue" element={<ComprendreBonusBienvenue />} />
        <Route path="/guides/types-paris-sportifs" element={<TypesParisSportifs />} />
        <Route path="/guides/guide-paris-hippiques" element={<GuideParisHippiques />} />
        <Route path="/guides/gestion-bankroll" element={<GestionBankroll />} />
        <Route path="/guides/strategies-paris" element={<StrategiesParis />} />
        <Route path="/guides/securite-protection-donnees" element={<SecuriteProtectionDonnees />} />
        <Route path="/guides/retraits-depots" element={<RetraitsDepots />} />
        <Route path="/guides/jeu-responsable" element={<JeuResponsable />} />
        <Route path="/news" element={<News />} />
        <Route path="/news/nouvelles-reglementations-anj-2025" element={<NouvellesReglementationsAnj2025 />} />
        <Route path="/news/comparatif-bonus-bienvenue-2025" element={<ComparatifBonusBienvenue2025 />} />
        <Route path="/news/tendances-paris-sportifs-2025" element={<TendancesParisSportifs2025 />} />
        <Route path="/news/nouveaux-operateurs-marche-francais" element={<NouveauxOperateursMarcheFrancais />} />
        <Route path="/news/impact-live-betting-habitudes-paris" element={<ImpactLiveBettingHabitudesParis />} />
        <Route path="/news/protection-joueurs-nouvelles-mesures-anj" element={<ProtectionJoueursNouvellesMesuresAnj />} />
        <Route path="/news/evolution-cotes-analyse-comparative" element={<EvolutionCotesAnalyseComparative />} />
        <Route path="/news/paris-hippiques-ere-numerique" element={<ParisHippiquesEreNumerique />} />
        <Route path="/news/methodes-paiement-2025" element={<MethodesPaiement2025 />} />
        <Route path="/reviews" element={<Reviews />} />
        <Route path="/reviews/betclic" element={<Betclic />} />
        <Route path="/reviews/olybet" element={<Olybet />} />
        <Route path="/reviews/genybet" element={<Genybet />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/cookies" element={<Cookies />} />
        <Route path="/responsible-gaming" element={<ResponsibleGaming />} />
      </Routes>
    </Router>
  );
}

export default App;
